import React from "react";
import "assets/styles/home/SolutionHome.scss";
import "font-awesome/css/font-awesome.min.css";
import TitleLeft from "../../common/sections/TitleLeft";

const SolutionHome = () => {
  const features = [
    {
      icon: "fa-user-circle",
      title: "Registro sencillo",
      description: "Regístrate fácilmente, sin costo y sin plazo forzoso"
    },
    {
      icon: "fa-credit-card",
      title: "Incrementa tus ventas",
      description: "Ofrece diferentes formas de pago y vende mucho más"
    },
    {
      icon: "fa-calculator",
      title: "Una sola terminal",
      description: "Acepta Visa, MasterCard, Amex y meses sin intereses"
    },
    {
      icon: "fa-shield",
      title: "Transacciones seguras",
      description: "Contamos con motores antifraudes, certificaciones PCI, y herramientas como Kount y G2 Risk"
    },
    {
      icon: "fa-map-marker",
      title: "Cobra en cualquier lugar",
      description: "Ofrece diferentes formas de pago e incrementa tus ventas"
    },
    {
      icon: "fa-desktop",
      title: "Monitoreo",
      description: "Acceso a un panel fácil e intuitivo para monitoreo en tiempo real"
    }
  ];

  return (
    <div className={'solutionHomeWrapper'}>
      <div className={'solutionHome'}>
        <TitleLeft>
          La mejor solución para aumentar las ventas de su negocio
        </TitleLeft>
        <div className={'solutionGrid'}>
          {features.map((feature, index) => (
            <React.Fragment key={index}>
              <div className={'solutionCard'}>
                <i className={`fa ${feature.icon} solutionIcon`}></i>
                <h3 className={'solutionTitle'}>{feature.title}</h3>
                <p className={'solutionDescription'}>{feature.description}</p>
              </div>
              {(index + 1) % 3 !== 0 && index !== features.length - 1 && (
                <div className={'solutionDivider'}></div>
              )}
            </React.Fragment>
          ))}
        </div>

        <div className={'solutionInfoBoxes'}>
          <div className={'solutionInfoBox'}>
            <i className="fa fa-headphones solutionInfoIcon"></i>
            <p>
              Te acompañamos en cada parte del proceso, brindándote <strong>soporte técnico y capacitación constante</strong>, asegurando una mayor aceptación con diferentes formas de pago.
            </p>
          </div>
          <div className={'solutionInfoBox'}>
            <p>
              Además, te ofrecemos un <strong>portal web fácil e intuitivo</strong> para revisar todas tus transacciones de manera rápida y sencilla.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolutionHome;
